import * as React from "react"
const KeyboardIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill={props.fill || "#CBCBCB"}
            d="M2 12c-.458 0-.823-.135-1.094-.406C.636 11.323.5 10.958.5 10.5v-9C.5 1.042.635.677.906.406 1.177.136 1.542 0 2 0h14c.458 0 .823.135 1.094.406.27.271.406.636.406 1.094v9c0 .458-.135.823-.406 1.094-.271.27-.636.406-1.094.406H2Zm0-1.5h14v-9H2v9Zm4-1h6V8H6v1.5ZM3.75 7h1.5V5.5h-1.5V7Zm3 0h1.5V5.5h-1.5V7Zm3 0h1.5V5.5h-1.5V7Zm3 0h1.5V5.5h-1.5V7Zm-9-2.5h1.5V3h-1.5v1.5Zm3 0h1.5V3h-1.5v1.5Zm3 0h1.5V3h-1.5v1.5Zm3 0h1.5V3h-1.5v1.5Z"
        />
    </svg>
)
export default KeyboardIcon
